module.exports = "pegasus/assets/themelp1/small/10.png";